
/// <amd-module name="Environments/Providers/Kubernetes/ImageLocationUtility" />
import { KubeImage } from "Environments/Providers/External/Kubernetes/Contracts/Contracts";
import { IVssPageContext } from "VSS/Platform/Context";
import { getAssetLocation } from "VSS/Platform/Location";

export class ImageLocationUtility {
    public static getImageLocation(pageContext: IVssPageContext, image: KubeImage): string | undefined {
        let imageName = "zero-data.svg";
        switch (image) {
            case KubeImage.zeroData:
            case KubeImage.resourceDeleted:
            case KubeImage.resourceAccessDenied:
                imageName = "zero-data.svg";
                break;

            case KubeImage.zeroResults:
                imageName = "zero-results.svg";
                break;

            case KubeImage.zeroWorkloads:
                imageName = "zero-workloads.svg";
                break;
        }

        return getAssetLocation(pageContext, `ms.vss-environments-web/providers.kubernetes/static/${imageName}`)
    }
}
